import { type ReactNode } from 'react'
import { type PermissionDefinition } from '@terros/common'
import { Text } from '@mantine/core'
import { stringifyPermissionScope } from './util'
import { PERM_GRAPH_RING_COLOR, type PermGraph } from './graph'

type Props = {
  definition: PermissionDefinition
  graph: PermGraph
}

export const PermGraphHeadline = ({ definition, graph }: Props): ReactNode => {
  const target = graph.nodes.find((node) => node.isTarget)
  const targetLabel = target?.label ?? 'This entity'
  const scope = target?.flowScope ?? 'none'

  return (
    <Text fw='bold' size='lg'>
      {scope === 'none' ? (
        `${targetLabel} cannot ${definition.action}`
      ) : (
        <>
          {`${targetLabel} can ${definition.action} for `}
          <Text c={PERM_GRAPH_RING_COLOR} fw='bold' inherit span>
            {stringifyPermissionScope(scope)}
          </Text>
        </>
      )}
    </Text>
  )
}
